<template>
    <div
        class="answer"
        :class="[feedbackBorder, answerSize]"
        @click="giveAnswer"
        v-bind:style="{ 'left': xPos+'%', 'top': yPos+'%', 'z-index':+y}"
    >
        <div v-if="checkVariation" class="imageContainer">
            <transition appear mode="out-in" name="fade">
                <img
                    :key="id"
                    v-if="!isAnimating"
                    class="image"
                    :src="'images/products/'+image"
                    :class="imageFeedback"
                >
            </transition>
        </div>
        <div v-else class="textContainer" :class="textFeedback">
            <transition appear mode="out-in" name="fade">
                <img
                    v-if="gameType=='training' && showFeedback && selectedID == id"
                    class="feedbackIcon"
                    :src="'images/'+getFeedbackIcon"
                    alt
                >
            </transition>
            <transition appear mode="out-in" name="fade">
                <h3 v-if="!isAnimating" v-html="body"></h3>
            </transition>
        </div>
    </div>
</template>

<script>
import { eventBus } from "../main";
import Fitty from "vue-fitty";
export default {
    name: "Answer",
    data() {
        return {
            isCorrect: false
        };
    },
    props: {
        id: {
            type: Number,
            required: true
        },
        body: {
            type: String,
            default: "",
            required: false
        },
        image: {
            type: String,
            default: "",
            required: false
        },
        variation: {
            type: Number,
            required: true
        },
        showFeedback: {
            type: Boolean,
            default: false
        },
        selectedID: {
            type: Number,
            default: 0
        },
        correctID: {
            type: Number,
            default: 0
        },
        isAnimating: {
            type: Boolean,
            default: false
        },
        x: {
            type: Number,
            default: 0
        },
        y: {
            type: Number,
            default: 0
        },
        gameType: {
            type: String,
            required: true
        },
        answeredCorrect: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        giveAnswer() {
            if (this.showFeedback == false) {
                var props = {
                    id: this.id
                };
                eventBus.$emit("answerWasGiven", props);
            }
        }
    },
    computed: {
        getFeedbackIcon() {
            if (this.answeredCorrect) {
                return "icon-correct.svg";
            } else {
                return "icon-incorrect.svg";
            }
        },
        xPos() {
            return this.x * 50;
        },
        yPos() {
            return this.y * 44;
        },
        checkVariation() {
            if (this.gameType == "fruitmachine") {
                if (this.variation == 0) {
                    return false;
                } else {
                    return true;
                }
            }
            if (this.gameType == "training") {
                return false;
            }
        },
        feedbackBorder() {
            if (this.showFeedback) {
                if (this.gameType == "fruitmachine") {
                    if (this.selectedID == this.id) {
                        if (this.id == this.correctID) {
                            return "feedbackCorrect";
                        }
                        if (this.id != this.correctID) {
                            return "feedbackIncorrect";
                        }
                    } else {
                        if (this.id == this.correctID) {
                            return "feedbackCorrectUp";
                        }
                    }
                }
                if (this.gameType == "training") {
                    if (this.selectedID == this.id) {
                        if (this.answeredCorrect) {
                            return "feedbackCorrectTraining";
                        } else {
                            return "feedbackIncorrectTraining";
                        }
                    } else {
                        return "buttonTraining";
                    }
                }
            } else if (this.gameType == "training") {
                return "buttonTraining";
            }
        },
        answerSize() {
            if (this.gameType == "fruitmachine") {
                return "small";
            }
            if (this.gameType == "training") {
                return "big";
            }
        },
        textFeedback() {
            if (this.showFeedback && this.gameType == "fruitmachine") {
                if (this.selectedID == this.id) {
                    if (this.id == this.correctID) {
                        return "textFeedback";
                    }
                    if (this.id != this.correctID) {
                        return "textFeedback";
                    }
                } else {
                    if (this.id == this.correctID) {
                        return "";
                    }
                }
            } else {
                return "";
            }
        },
        imageFeedback() {
            if (this.showFeedback) {
                if (this.selectedID == this.id) {
                    if (this.id == this.correctID) {
                        return "imageFeedback";
                    }
                    if (this.id != this.correctID) {
                        return "imageFeedback";
                    }
                } else {
                    if (this.id == this.correctID) {
                        return "";
                    }
                }
            } else {
                return "image";
            }
        }
    }
};
</script>

<style scoped>
.answer {
    display: inline-block;
    position: absolute;
    left: 0;
    width: 47%;
    height: 50%;
    background-image: url(../assets/images/button-orange-up.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
}
.buttonTraining {
    background-image: url(../assets/images/button-orange-training.svg);
}
.feedbackIcon {
    position: absolute;
    width: 15%;
    top: 13%;
    left: 45%;
}
.small {
}
.big {
    height: 150%;
}
.answer:hover {
    cursor: pointer;
}

.imageContainer {
    height: 100%;
    width: 100%;
}
.image {
    height: 65%;
    width: auto;
    max-width: 75%;
    margin-top: 5%;
}
.imageFeedback {
    margin-top: 15%;
}
.textContainer {
    display: table;
    height: 80%;
    width: 100%;
}

.textFeedback {
    height: 100%;
}
.feedbackCorrect {
    background-image: url(../assets/images/button-green-down.svg);
    background-repeat: no-repeat;
    background-position: center bottom;
}
.feedbackCorrectUp {
    background-image: url(../assets/images/button-green-up.svg);
    background-repeat: no-repeat;
    background-position: center bottom;
}
.feedbackIncorrect {
    background-image: url(../assets/images/button-red-down.svg);
    background-repeat: no-repeat;
    background-position: center bottom;
}
.feedbackIncorrectUp {
    background-image: url(../assets/images/button-red-up.svg);
    background-repeat: no-repeat;
    background-position: center bottom;
}
.feedbackCorrectTraining {
    background-image: url(../assets/images/button-green-training.svg);
    background-repeat: no-repeat;
    background-position: center bottom;
}
.feedbackIncorrectTraining {
    background-image: url(../assets/images/button-red-training.svg);
    background-repeat: no-repeat;
    background-position: center bottom;
}

h3 {
    display: table-cell;
    padding: 3% 6%;
    vertical-align: middle;
    text-shadow: 0px -2px 0px rgba(0, 0, 0, 0.35);
    color: #fff;
}
</style>
